import { render, staticRenderFns } from "./NYTGames.vue?vue&type=template&id=2ccabb9c&scoped=true"
import script from "./NYTGames.js?vue&type=script&lang=js&external"
export * from "./NYTGames.js?vue&type=script&lang=js&external"
import style0 from "./NYTGames.scss?vue&type=style&index=0&id=2ccabb9c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccabb9c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NYTGamesCard: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTGamesCard/NYTGamesCard.vue').default})
